export const LYTEFLO_LOGIN_ENABLED_KEY = "lf_lyteflo_login_enabled";
export const PWA_INSTALLATION_SOURCE_KEY = "lf_pwa_installation_source";
export const PWA_BANNER_ANDROID_DISMISSED_KEY =
  "lf_pwa_banner_android_dismissed";
export const PWA_BANNER_IOS_DISMISSED_KEY = "lf_pwa_banner_ios_dismissed";

export enum Platform {
  IOS = "ios",
  ANDROID = "android",
}

export enum DeviceType {
  MOBILE = "mobile",
  DESKTOP = "desktop",
}

export enum DeviceOS {
  IOS = "iOS",
  ANDROID = "Android",
  MAC = "Mac",
  WINDOWS = "Windows",
}
